import { PaymentWidget } from "./PaymentWidget";
import api from "../../api";

export class PaypalWidget extends PaymentWidget {
    scriptGlobalVar = "paypal";
    paypalButtonRendered = false;
    loadingCheckInterval = null;
    paypalSdkLoaded = false;

    init() {
        if (this.initialized) return;
        this.paymentData = this.dataJson("payment-data");
        this.loadExternalScript(`https://www.paypal.com/sdk/js?client-id=${window.app.payments.paypal.client_id}&components=buttons&currency=USD&locale=${this.paymentData.language}`)
            .then(() => {
                this.paypalSdkLoaded = true;
                this.emit("loaded");
                super.init();
                if (this.paymentData) this.show();
            })
            .catch((error) => {
                this.clearLoadingState();
                this.error({ error: "Не удалось загрузить платежную систему" });
            });
    }

    show() {
        if (this.paymentCompleted) return;
        super.show();
        this.addClass("loading");
        const startTime = Date.now();

        if (this.loadingCheckInterval) {
            clearTimeout(this.loadingCheckInterval);
        }

        this.loadingCheckInterval = setTimeout(() => {
            if (this.paypalSdkLoaded && window.paypal) {
                this.clearLoadingState();
                this.renderBtn();
            } else if (Date.now() - startTime > 10000) {
                this.clearLoadingState();
                this.error({ error: "Не удалось загрузить PayPal" });
            }
        }, 200);
    }

    clearLoadingState() {
        if (this.loadingCheckInterval) {
            clearTimeout(this.loadingCheckInterval);
            this.loadingCheckInterval = null;
        }
        this.removeClass("loading");
        this.setLoadingState(false);
    }

    renderBtn() {
        if (!window.paypal || !window.paypal.Buttons) return;
        this.empty();
        this.paypalButtonRendered = true;
            window.paypal
                .Buttons({
                    style: {
                        shape: "pill",
                        layout: "vertical",
                        color: "gold",
                        height: 55,
                        label: "pay",
                    },
                    createOrder: () =>
                        this.createOrderCallback(this.paymentData),
                    onApprove: (data) => this.onApproveCallback(this.paymentData, data),

                    onError: (err) => {
                        this.error({
                            error: "Ошибка PayPal",
                            details: err.message || err.toString(),
                        });
                    },
                })
              .render(this.el());
    }

    async createOrderCallback(paymentData) {
        try {
            this.setLoadingState(true);
            const response = await api.post(
                "/payment/paypal/create/" + paymentData.invoice
            );
            return response.order_id;
        } catch (error) {
            this.error({
                error: "Ошибка создания платежа",
                details: error.response?.data?.message || error.message,
            });
        } finally {
            this.setLoadingState(false);
        }
    }

    async onApproveCallback(paymentData, data) {
        try {
            this.setLoadingState(true);
            const response = await api.post("/payment/paypal/capture/" + paymentData.invoice, { orderID: data.orderID });
            this.paymentCompleted = true;
            this.success({
                ...response.data,
                id: data.orderID,
                invoice: paymentData.invoice,
            });
        } catch (error) {
            this.error({
                error: "Ошибка подтверждения платежа",
                details: error.message,
            });
        } finally {
            this.setLoadingState(false);
        }
    }

    async success(details) {
        try {
            const successData = {
                id: details.id,
                invoice: details.invoice,
            };

            await super.success(successData);
        } catch (error) {
            console.error("Error handling success:", error);

        }
    }
}
